export const FETCH_CREATE_FOLDER = 'FETCH_CREATE_FOLDER';
export const FETCH_UPDATE_FOLDER = 'FETCH_UPDATE_FOLDER';
export const FETCH_DELETE_FOLDER = 'FETCH_DELETE_FOLDER';
export const FETCH_GET_FOLDER = 'FETCH_GET_FOLDER';
export const FETCH_GET_ALL_FOLDERS = 'FETCH_GET_ALL_FOLDERS';
export const FETCH_GET_ARCHIVED_FOLDERS = 'FETCH_GET_ALL_FOLDERS';
export const DEFAULT_FOLDER_NAME = '<DefaultFolder>';
export const FETCH_ARCHIVE_FOLDER = 'FETCH_ARCHIVE_FOLDER';
